import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

import { commitNumericDraft } from '../../utils/numericFieldUtils';

/**
 * Numeric optimize parameter field: keeps a string draft while editing so
 * the operator can clear the box and type a new value without snapping back.
 */
const NumericParamField = ({
  value,
  onChange,
  fallback,
  min,
  max,
  parse,
  inputProps,
  ...rest
}) => {
  const [draft, setDraft] = useState(String(value ?? ''));

  useEffect(() => {
    setDraft(String(value ?? ''));
  }, [value]);

  return (
    <TextField
      {...rest}
      type="number"
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        const committed = commitNumericDraft(draft, {
          min,
          max,
          fallback: fallback ?? value,
          parse,
        });
        onChange(committed);
        setDraft(String(committed));
      }}
      inputProps={{ min, max, ...inputProps }}
    />
  );
};

export default NumericParamField;
